module.exports = __webpack_public_path__ + "static/media/createPhoneNumber_error.5a819027.svg";